var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"period-switch"},_vm._l((_vm.options),function(opt){return _c('button',{key:opt.value,staticClass:"period-switch__item",class:{ 'period-switch__item--active': _vm.value === opt.value },attrs:{"type":"button"},on:{"click":function($event){return _vm.select(opt.value)}}},[_vm._v("\n    "+_vm._s(opt.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }